<google-map
  [center]="center"
  [zoom]="zoom"
  height="200px"
  width="100%"
  (mapClick)="moveMarker($event)"
>
  <map-marker *ngIf="marker" [position]="marker"></map-marker>
</google-map>
